import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from '@m3-tech/boss-api'
import { API_BC_NEEDS_ATTENTION_COUNTS } from '@/constants/apiRoutes'
import { BC_NEEDS_ATTENTION_COUNTS_QUERY_KEY } from '@/constants/queryKeys'
import type { BcCounts, BcNeedsAttentionPaths } from '@/types/bcNeedsAttention.types'
import { BcApiError } from '@/utils/bcNeedsAttention.utils'

/**
 * The menu badge and both tab badges, without loading either table.
 *
 * The menu calls it on every settings page, so it is gated by the caller
 * (`enabled` = the user is a Payroll Manager) and never raises the global Access
 * Denied overlay: a 403 here only means "hide the menu item".
 */
export function useBcNeedsAttentionCounts({ enabled = true }: { enabled?: boolean } = {}) {
    const client = useTypedApiClient<BcNeedsAttentionPaths>({ suppressAccessDenied: true })

    return useQuery({
        queryKey: BC_NEEDS_ATTENTION_COUNTS_QUERY_KEY,
        enabled,
        staleTime: 30_000,
        retry: false,
        queryFn: async (): Promise<BcCounts> => {
            const { data, error, response } = await client.GET(API_BC_NEEDS_ATTENTION_COUNTS)
            if (error !== undefined || !data) throw new BcApiError(response.status, error)
            return data
        },
    })
}
